import React from "react";
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import moment from "moment";
import { MaskFormatted } from "src/helper/mask-helper";
const ClinicExportToExcel = ((props, ref) => {
  const { clinicList } = props;
  const clinicExportToExcelList = convertList(clinicList);
  const _exporter = React.useRef(null);
  const exportExcel = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  }
  function convertList(originalList) {
    const newList = [];
    for (const item of originalList) {
      const obj = {
        ClinicID: item?.masterClinicId,
        ClinicName: item?.clinicName,
        DomainName: item?.domainName,
        CustomerStatusName: item?.customerStatusName || "",
        StripeCustomerID: item?.stripeCustomerId,
        RegionName: item?.regionName,
        Status: item?.status,
        Address: `Address: ${item?.address || ''}, City: ${item?.city || ''}, State: ${item?.state || ''}, Zip: ${item?.zip ? (item.zip.length != 9 ? item.zip : `${item.zip.substring(0,5)}-${item.zip.substring(5)}`) : ''}`,
        Phone: MaskFormatted(item?.phone, "(999) 999-9999"),
        Email: item?.email,
        TextReminders: item?.enableTextReminders ? "Yes" : "No",
        UserSeats: `${item?.activeStaffCount || 0}/${
          item?.maxAllowedUserSeats || 0
        }/${item?.startingUserCounts || 0}`,
        JoinDate: item?.utcDateCreated != null ? moment(item?.utcDateCreated).format("MM/DD/YYYY") : "N/A",
        SubscriptionStartDate: item?.subscriptionStartDate != null ? moment(item?.subscriptionStartDate).format("MM/DD/YYYY") : "N/A",
        CommissionPercentage: item?.commissionPercentage != null ? item?.commissionPercentage : "",
        SalesPerson: item?.salesPerson || "",
        Referral: item?.referral || "",
        LastLogin: item?.utcLastLogin != null ? moment(item?.utcLastLogin).format("MM/DD/YYYY") : "N/A"
      };
      newList.push(obj);
    }
    return newList;
  }
  return (
    <div>
      <button
        type="button"
        onClick={exportExcel}
        className="btn blue-primary text-white d-flex align-items-center mt-1  green-btn btn-primary"
      >
        <i className="fa fa-file-excel mr-2" />
        Export to Excel
      </button>
      <ExcelExport
        data={clinicExportToExcelList}
        fileName="Clinics.xlsx"
        ref={_exporter}
      >
        <ExcelExportColumn field="ClinicID" title="Clinic ID" width={120} locked={true} />
        <ExcelExportColumn field="ClinicName" title="Clinic Name" width={150} />
        <ExcelExportColumn field="DomainName" title="Domain Name" width={150} />
        <ExcelExportColumn field="CustomerStatusName" title="Customer Status" width={150}/>
        <ExcelExportColumn field="StripeCustomerID" title="Stripe Customer ID" width={150} />
        <ExcelExportColumn field="RegionName" title="Region Name" width={150} />
        <ExcelExportColumn field="Status" title="Status" width={100} />
        <ExcelExportColumn field="Address" title="Address" />
        <ExcelExportColumn field="Phone" title="Phone" width={150} />
        <ExcelExportColumn field="Email" title="Email" width={200} />
        <ExcelExportColumn field="TextReminders" title="Text Reminders" width={150} />
        <ExcelExportColumn field="UserSeats" title="User Seats (Used/Total/Initial)" width={190} />
        <ExcelExportColumn field="JoinDate" title="Join Date" width={150} />
        <ExcelExportColumn field="SubscriptionStartDate" title="Subscription Start Date" width={190} />
        <ExcelExportColumn field="CommissionPercentage" title="Commission %" width={150} />
        <ExcelExportColumn field="SalesPerson" title="Sales Person" width={150} />
        <ExcelExportColumn field="Referral" title="Referral" width={150} />
        <ExcelExportColumn field="LastLogin" title="Last log in" width={150} />
      </ExcelExport>
    </div>
  );
});
export default ClinicExportToExcel;
